import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Step, TerminateDepotBase } from '@zero/self-service/feature-self-service/base';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { TransactionAuthorizationComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'self-service-terminate-depot',
  templateUrl: './terminate-depot.component.html',
  styleUrls: ['./terminate-depot.component.scss'],
  imports: [
    NgTemplateOutlet,
    RouterLink,
    NgClass,
    LoadingIndicatorDirective,
    TransactionAuthorizationComponent,
    AsyncPipe,
    TranslocoPipe,
    ButtonComponent,
    ModalComponent,
  ],
})
export class TerminateDepotComponent extends TerminateDepotBase {
  @ViewChild('modal') public modal?: TemplateRef<HTMLElement>;

  public readonly commonRoutes = commonRoutes;
  readonly #modal = inject(NgbModal);
  readonly #router = inject(Router);

  readonly #modalConfig: NgbModalOptions = {
    size: 'lg',
    backdrop: 'static',
    beforeDismiss: () => {
      this.currentStep = Step.HINT;
      return true;
    },
  };

  constructor() {
    super();
    this.#router.events.forEach((event) => event instanceof NavigationStart && this.#modal.dismissAll());
  }

  public start(): void {
    this.terminateDepotFacade.loadChecklist();
    this.#modal.open(this.modal, this.#modalConfig);
  }

  public close(): void {
    this.#modal.dismissAll();
  }

  public handleSuccess(): void {
    this.close();
    this.logout.emit();
  }
}
